import { useState } from 'react';
import { format } from 'date-fns';
import { auditTrailApi } from '@/services/auditTrailApi';
import { toast } from 'sonner';
import { downloadCsv } from '@/utils/reportCsv';
import type { AuditTrailQuery } from '@/utils/AuditTrail/types';
import { mapAuditTrailRow } from '@/utils/AuditTrail/mappers';
import { buildAuditTrailCsv } from '@/utils/AuditTrail/csv';

interface UseAuditTrailExportParams {
  allowExport: boolean;
  query: AuditTrailQuery;
}

export function useAuditTrailExport({ allowExport, query }: UseAuditTrailExportParams) {
  const [isExporting, setIsExporting] = useState(false);

  // Export CSV — every row matching the current filters, not just the visible page
  const handleExport = async () => {
    if (!allowExport) return;
    setIsExporting(true);
    try {
      const exportRows = (await auditTrailApi.getAllAuditTrailRows(query)).map(mapAuditTrailRow);
      downloadCsv(buildAuditTrailCsv(exportRows), `audit-trail-${format(new Date(), 'yyyy-MM-dd')}.csv`);

      toast.success('Export successful', {
        description: `Exported ${exportRows.length} timesheet entries to CSV.`,
      });
    } catch {
      toast.error('Export failed', { description: 'There was an error generating the CSV.' });
    } finally {
      setIsExporting(false);
    }
  };

  return { isExporting, handleExport };
}
